// eslint-disable-next-line no-restricted-imports
import { api, HandlePopupRequestApiDto, PopupEventApiType } from '@b2x/storefront-api-js-client/src';
import { HandlePopupsOptions } from '@b2x/storefront-api-js-client/src/popups';
import React from 'react';

import { PopupContentTypeV2 } from '../contentTypes';
import { ApiRequestConfig, useApiRequest } from './useApiRequest';

export const usePopupsApi = () => {
  const { apiRequest } = useApiRequest();

  const handlePopups = React.useCallback(
    (
      event: PopupEventApiType,
      url: string,
      popupsToExclude: Array<string>,
      data: HandlePopupRequestApiDto,
      options?: HandlePopupsOptions,
      config?: ApiRequestConfig
    ) =>
      apiRequest(api.popups.handlePopups<PopupContentTypeV2>(event, url, popupsToExclude, data, options), {
        ...config,
        suppressErrorModal: true,
      }),
    [apiRequest]
  );

  return { handlePopups };
};

export const useGetPopupById = () => {
  const { apiRequest } = useApiRequest();

  const getPopupById = React.useCallback(
    (...params: Parameters<typeof api.popups.getPopupById<PopupContentTypeV2>>) =>
      apiRequest(api.popups.getPopupById<PopupContentTypeV2>(...params)),
    [apiRequest]
  );

  return { getPopupById };
};
